<template>
  <div ref="wrapRef" class="mts-page-container" v-bind="$attrs">
    <MHeader v-if="!hideHeader" v-bind="{ ...headerProps, headerGap, showBack, beforeBackFn }">
      <template v-for="item in Object.keys($slots)" #[item]="data">
        <slot :name="item" v-bind="data || {}"></slot>
      </template>
    </MHeader>

    <div :class="['flex flex-1 flex-col overflow-auto', contentClass]">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { AllowedComponentProps, ref } from 'vue';
  import { MHeader } from '@mts/components/Header';

  defineOptions({ name: 'MPage', inheritAttrs: false });

  withDefaults(
    defineProps<{
      /** 页面标题 */
      title?: string;
      /** 隐藏头部 */
      hideHeader?: boolean;
      /** 标题行底部间隔 */
      headerGap?: boolean;
      headerProps?: AllowedComponentProps;
      /** 显示返回按钮 */
      showBack?: boolean;
      /** 默认返回事件前，false取消执行 */
      beforeBackFn?: () => Promise<void | false>;
      contentClass?: string;
    }>(),
    {},
  );

  const wrapRef = ref(null);
  defineExpose({ wrapRef });
</script>

<style lang="less">
  .mts-pc .mts-page-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: fill-available;
    max-width: -webkit-fill-available;
    min-height: calc(100vh - 56px);
    margin: 4px;

    .ant-tabs {
      max-width: fill-available;
      max-width: -webkit-fill-available;
      color: #596579;

      &.ant-tabs-top > .ant-tabs-nav {
        margin-bottom: 8px;
      }
    }
  }
</style>
